/**
 * Copyright (c) Microsoft. All rights reserved.
 */

// tslint:disable:no-any
// tslint:disable:export-name
// tslint:disable:function-name

export function toJson(obj: any): string {
    try {
        return JSON.stringify(obj);
    } catch (error) {
        return `Unable to serialize object of type ${typeof obj}`;
    }
}

export function calculateTtlInSec(expirationTsInSec: number | undefined): number {
    const now = Math.round(new Date().getTime() / 1000);

    return expirationTsInSec !== undefined && expirationTsInSec > now
        ? expirationTsInSec - now
        : 0;
}

export function calculateExpireTsInSec(ttlInSec: number): number {
    return Math.round(new Date().getTime() / 1000) + ttlInSec;
}

/** Wrapper to send request with specified timeout */
export async function fetchWithTimeout(request: Request, timeoutMs: number): Promise<Response> {
    let timeoutId: number | undefined;
    const fetchPromise = new Promise<Response>((resolve, reject) => {
        fetch(request).then((response) => {
            clearTimeout(timeoutId);
            resolve(response);
        }).catch((error) => {
            clearTimeout(timeoutId);
            reject(error);
        });
    });
    if (timeoutMs !== 0) {
        const timeoutPromise = new Promise<Response>((resolve, reject) => {
            // We make a compromise on how much information to show in the error message.
            // Having the URL there is useful, but including any query parameters is both
            // cumbersome (millions of different errors in telemetry) and unsafe (secret
            // fields that would need to be redacted). "Origin" and "pathname" achieve that.
            const url = new URL(request.url);
            const error = new Error(`${request.method} ${url.origin}${url.pathname} timed out`);
            // tslint:disable-next-line:no-string-based-set-timeout - false positive on 'reject'
            timeoutId = setTimeout(reject, timeoutMs, error);
            });

        return Promise.race([fetchPromise, timeoutPromise]);
    }

    return fetchPromise;
}

/***
 * Correlation vector
 */
export class CorrelationVector {
    private base: string;
    private extension: number;

    private constructor(correlationVector?: string) {
        this.base = (correlationVector !== undefined) ? correlationVector : this.createCorrelationVectorBase();
        this.extension = 0;
    }

    public static extend(correlationVector?: string): CorrelationVector {
        return new CorrelationVector(correlationVector);
    }

    public increase() {
        this.extension++;
    }

    public value(): string {
        return `${this.base}.${this.extension}`;
    }

    private createCorrelationVectorBase(): string {
        const length = 21;
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0987654321/+';
        const endChars = 'AQgw';
        let result = '';
        for (let i = 0; i < length; i++) {
            // tslint:disable-next-line:insecure-random
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        // tslint:disable-next-line:insecure-random
        result += endChars.charAt(Math.floor(Math.random() * endChars.length));

        return result;
    }
}

/**
 * Simplify calculation of time intervals
 */
export class Timespan {
    private start: number;

    constructor() {
        this.start = Date.now();
    }

    /**
     * Returns number of milliseconds from start
     */
    public get duration(): number {
        return Date.now() - this.start;
    }

    /**
     * Returns start time
     */
    public get startTime() {
        return this.start;
    }

    /**
     * Reset start of interval to current timestamp
     */
    public reset() {
        this.start = Date.now();
    }
}



// WEBPACK FOOTER //
// ./lib_temp/Common.ts